import { PropsWithChildren } from 'react'
import css from './adminNavigationProtectionLayout.module.css'
import NavigationLink from 'navigation/components/NavigationLink'
import { ReactComponent as EventsIcon } from 'assets/icons/event.svg'
import { ReactComponent as SkillsIcon } from 'assets/icons/skill.svg'
import ProtectionScheduleAdminPage from 'screens/Protection/pages/AdminProtection/ProtectionSchedule'
import ProtectionGradeAdminPage from 'screens/Protection/pages/AdminProtection/ProtectionGrade'

const AdminNavigationProtectionLayout = (props: PropsWithChildren<unknown>) => {
  return (
    <div className={css.content}>
      <div className={css.leftCol}>
        <NavigationLink
          route={{
            path: '/admin/protection-admin',
            element: <ProtectionScheduleAdminPage />,
            title: 'Расписание защит',
            icon: <EventsIcon style={{ width: '24px', height: '24px', margin: '5px 0' }} />,
          }}
          className={css.navLink}
        />
        <NavigationLink
          route={{
            path: '/admin/protection-grade',
            element: <ProtectionGradeAdminPage />,
            title: 'Оценки',
            icon: <SkillsIcon style={{ width: '24px', height: '24px', margin: '5px 0' }} />,
          }}
          className={css.navLink}
        />
      </div>
      {props.children}
    </div>
  )
}

export default AdminNavigationProtectionLayout
